export const domain = 'StoreLocation';

// action types
export const CLOSE_STORE_MODAL = `${domain}/CLOSE_STORE_MODAL`;
export const OPEN_STORE_MODAL = `${domain}/OPEN_STORE_MODAL`;
export const SAVE_SELECTED_LOCATION = `${domain}/SAVE_SELECTED_LOCATION`;
